import type { DocTemplate } from '../../types/docops';

export { SEED_CATEGORIES } from './seedCategories';
export { DEFAULT_BRAND_CONFIG } from './defaultBrandConfig';
export { SEED_OWNER_PROFILE } from './seedOwnerProfile';

import { SEED_TEMPLATES_USER_LEGAL } from './seedTemplates01UserLegal';
import { SEED_TEMPLATES_CORPORATE } from './seedTemplates02Corporate';
import { SEED_TEMPLATES_TRUST_IP } from './seedTemplates03TrustIP';
import { SEED_TEMPLATES_MSO_PC } from './seedTemplates04MsoPc';
import { SEED_TEMPLATES_HIPAA } from './seedTemplates05Hipaa';
import { SEED_TEMPLATES_VENDOR } from './seedTemplates06Vendor';
import { SEED_TEMPLATES_EMPLOYMENT } from './seedTemplates07Employment';
import { SEED_TEMPLATES_COMPLIANCE } from './seedTemplates08Compliance';
import { SEED_TEMPLATES_DASHBOARDS } from './seedTemplates09Dashboards';
import { SEED_TEMPLATES_BUSINESS } from './seedTemplates10Business';
import { SEED_TEMPLATES_ACQUISITION } from './seedTemplates11Acquisition';
import { SEED_TEMPLATES_CLINICAL } from './seedTemplates12Clinical';
import { SEED_TEMPLATES_SOC2 } from './seedTemplates13Soc2';

export const ALL_SEED_TEMPLATES: DocTemplate[] = [
  ...SEED_TEMPLATES_USER_LEGAL,
  ...SEED_TEMPLATES_CORPORATE,
  ...SEED_TEMPLATES_TRUST_IP,
  ...SEED_TEMPLATES_MSO_PC,
  ...SEED_TEMPLATES_HIPAA,
  ...SEED_TEMPLATES_VENDOR,
  ...SEED_TEMPLATES_EMPLOYMENT,
  ...SEED_TEMPLATES_COMPLIANCE,
  ...SEED_TEMPLATES_DASHBOARDS,
  ...SEED_TEMPLATES_BUSINESS,
  ...SEED_TEMPLATES_ACQUISITION,
  ...SEED_TEMPLATES_CLINICAL,
  ...SEED_TEMPLATES_SOC2,
];

// Re-export individual category arrays for selective seeding
export {
  SEED_TEMPLATES_USER_LEGAL,
  SEED_TEMPLATES_CORPORATE,
  SEED_TEMPLATES_TRUST_IP,
  SEED_TEMPLATES_MSO_PC,
  SEED_TEMPLATES_HIPAA,
  SEED_TEMPLATES_VENDOR,
  SEED_TEMPLATES_EMPLOYMENT,
  SEED_TEMPLATES_COMPLIANCE,
  SEED_TEMPLATES_DASHBOARDS,
  SEED_TEMPLATES_BUSINESS,
  SEED_TEMPLATES_ACQUISITION,
  SEED_TEMPLATES_CLINICAL,
  SEED_TEMPLATES_SOC2,
};
